/**
 * @Description: 审核模态框
 * @author zhaijiayu
 * @date 2021/10/28
*/
<template>
  <el-dialog
    class="audit-modal"
    width="500px"
    :visible="true"
    :title="result | getTitle"
    @close="onCancel"
  >
    <section class="item" v-if="result === 'INTERNAL_SUCCESS'">
      <label>继续审核</label>
      <div class="content">
        <el-radio-group v-model="isContinue">
          <el-radio :label="false">结束审核</el-radio>
          <el-radio :label="true">提交下一人审核</el-radio>
        </el-radio-group>
        <div class="auditor" v-show="isContinue">
          <el-select
              v-model="auditor"
              filterable
              allow-create
              default-first-option
              placeholder="请输入审核人手机号"
          >
            <el-option
                v-for="item in recentAuditors"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </section>
    <section class="item">
      <label>审核意见</label>
      <div class="content">
        <el-input
            v-model="adjust"
            type="textarea"
            maxlength="50"
            show-word-limit
            resize="none"
            rows="5"
        />
      </div>
    </section>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {RESOURCE_HOST} from "../constants/apiHosts";

export default {
  props: {
    // 审核结果
    result: String,
    // 审核取消回调
    onCancel: Function,
    // 审核完成回调
    onConfirm: Function,
    id: Number | String
  },
  filters: {
    getTitle: function (result){
      return {
        'INTERNAL_FAIL': '审核不通过',
        'INTERNAL_SUCCESS': '审核通过'
      }[result]
    }
  },
  name: "aduit-modal",
  data: function (){
    return {
      auditor: '',
      isContinue: false,
      adjust: '',
      recentAuditors: [],
    }
  },
  async mounted() {
    await this.getRecentAuditors()
  },
  methods: {
    // 获取最近审核人
    getRecentAuditors: async function(){
      const { data } = await this.$axios.post(`${RESOURCE_HOST}/api/common/getaudituserlist`)
      const userList = data.data || {}
      for(let key in userList){
        this.recentAuditors.push({
          label: userList[key].u_cellphone,
          value: userList[key].u_cellphone,
        })
      }
    },
    handleConfirm: async function(){
      let auditorId = ''
      if(this.result === 'INTERNAL_SUCCESS' && this.isContinue){
        const rs = await this.getUidByPhone()
        if(!rs) return
        auditorId = rs
      }
      try{
        await this.$axios(`${RESOURCE_HOST}/api/newsinternalaudit/operation`, {
          method: "post",
          data: {
            id: this.id,
            status: this.result,
            audit_uid: auditorId,
            audit_record: this.adjust
          },
        })
        this.$message({
          message: "审批成功",
          type: "success",
        });
      }catch (e) {
        console.log(e)
      }
      this.onConfirm && this.onConfirm()
    },
    // 根据手机号获取用户的uid
    getUidByPhone: async function(){
      try {
        const {data} = await this.$axios.post(`${RESOURCE_HOST}/api/common/getaudituser`, {
          cellphone: this.auditor,
        })
        if(data.code !== 0){
          this.$message({
            message: data.msg || '输入的手机号有误',
            type: 'error'
          })
          return false
        }
        return data.data
      }catch (e){
        console.log(e)
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./src/styles/variables";

.audit-modal{
  .item{
    display: flex;

    label{
      color: $text-color-main;
    }
    .content{
      flex: 1;
      margin-left: 20px;
      margin-bottom: 24px;

      .auditor{
        margin-top: 20px;
      }
    }
  }
}
</style>